<!--
 * @Author: yang.yang
 * @Description: 通用图片组件，图片宽高自适应占满容器（cover）
 -->

<template>
  <div class="custom-image" :style="{ borderRadius }">
    <transition name="fade">
      <div
        @click="handlePreview"
        :style="{
          backgroundImage: `url(${src})`,
        }"
      >
      </div>
    </transition>
    <div class="placeholder"></div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'

export default {
  props: {
    src: String,
    borderRadius: {
      type: String,
      default: '0',
    },
    preview: {
      type: Boolean,
      default: false,
    },
    previewList: {
      type: Array,
      default () {
        return []
      },
    },
  },
  methods: {
    handlePreview() {
      if (!this.preview) return
      const list = this.previewList.length ? this.previewList : [this.src]
      ImagePreview({
        images: list,
        showIndex: list.length > 1,
        maxZoom: 3,
        minZoom: 0.3,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .custom-image {
    position: relative;
    overflow: hidden;
    div {
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
      font-size: 0;
      background-size: cover;
      &.placeholder {
        z-index: 0;
        background: $color-background;
      }
    }
  }
</style>
